export const transliterationMap: Record<string, string> = {
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  å: 'a',
  æ: 'ae',
  ā: 'a',
  ą: 'a',
  ă: 'a',
  ç: 'c',
  ć: 'c',
  č: 'c',
  ĉ: 'c',
  ċ: 'c',
  ď: 'd',
  đ: 'd',
  ð: 'd',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ē: 'e',
  ę: 'e',
  ě: 'e',
  ĕ: 'e',
  ė: 'e',
  ĝ: 'g',
  ğ: 'g',
  ġ: 'g',
  ģ: 'g',
  ĥ: 'h',
  ħ: 'h',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  ī: 'i',
  ĩ: 'i',
  ĭ: 'i',
  į: 'i',
  ı: 'i',
  ĵ: 'j',
  ķ: 'k',
  ĸ: 'k',
  ł: 'l',
  ľ: 'l',
  ĺ: 'l',
  ļ: 'l',
  ŀ: 'l',
  ñ: 'n',
  ń: 'n',
  ň: 'n',
  ņ: 'n',
  ŉ: 'n',
  ŋ: 'n',
  ò: 'o',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ø: 'o',
  ō: 'o',
  ő: 'o',
  ŏ: 'o',
  œ: 'oe',
  ŕ: 'r',
  ř: 'r',
  ŗ: 'r',
  ś: 's',
  š: 's',
  ş: 's',
  ŝ: 's',
  ș: 's',
  ß: 'ss',
  ť: 't',
  ţ: 't',
  ŧ: 't',
  ț: 't',
  þ: 'th',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u',
  ū: 'u',
  ů: 'u',
  ű: 'u',
  ŭ: 'u',
  ũ: 'u',
  ų: 'u',
  ŵ: 'w',
  ý: 'y',
  ÿ: 'y',
  ŷ: 'y',
  ž: 'z',
  ź: 'z',
  ż: 'z',
  ạ: 'a',
  ả: 'a',
  ấ: 'a',
  ầ: 'a',
  ẩ: 'a',
  ẫ: 'a',
  ậ: 'a',
  ắ: 'a',
  ằ: 'a',
  ẳ: 'a',
  ẵ: 'a',
  ặ: 'a',
  ẹ: 'e',
  ẻ: 'e',
  ẽ: 'e',
  ế: 'e',
  ề: 'e',
  ể: 'e',
  ễ: 'e',
  ệ: 'e',
  ỉ: 'i',
  ị: 'i',
  ọ: 'o',
  ỏ: 'o',
  ố: 'o',
  ồ: 'o',
  ổ: 'o',
  ỗ: 'o',
  ộ: 'o',
  ớ: 'o',
  ờ: 'o',
  ở: 'o',
  ỡ: 'o',
  ợ: 'o',
  ụ: 'u',
  ủ: 'u',
  ứ: 'u',
  ừ: 'u',
  ử: 'u',
  ữ: 'u',
  ự: 'u',
  ỳ: 'y',
  ỵ: 'y',
  ỷ: 'y',
  ỹ: 'y',
};
